"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _serializr = require("serializr");
var _utils = require("@seedlang/utils");
var _lodash = require("lodash");
var _root_model = _interopRequireDefault(require("./root_model"));
var _translation_source_basic = _interopRequireDefault(require("./translation_source_basic"));
var _word_type = _interopRequireDefault(require("./word_type"));
var _root_word = _interopRequireDefault(require("./root_word"));
var _level = _interopRequireDefault(require("./level"));
var _concept_basic = _interopRequireDefault(require("./concept_basic"));
var _conjugated_verb_string = _interopRequireDefault(require("./conjugated_verb_string"));
var _target_basic = _interopRequireDefault(require("./target_basic"));
var _constants = require("@seedlang/constants");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _descriptor49; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var TranslationBasic = (_dec = (0, _serializr.serializable)((0, _serializr.custom)(function (item) {
  return item;
}, function (item) {
  return item;
})), _dec2 = (0, _serializr.serializable)((0, _serializr.object)(_word_type["default"])), _dec3 = (0, _serializr.serializable)((0, _serializr.object)(_level["default"])), _dec4 = (0, _serializr.serializable)((0, _serializr.object)(_target_basic["default"])), _dec5 = (0, _serializr.serializable)((0, _serializr.object)(_root_word["default"])), _dec6 = (0, _serializr.serializable)((0, _serializr.object)(_root_word["default"])), _dec7 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_root_word["default"]))), _dec8 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_concept_basic["default"]))), _dec9 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_translation_source_basic["default"]))), _dec0 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_translation_source_basic["default"]))), _dec1 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_conjugated_verb_string["default"]))), _class = /*#__PURE__*/function (_RootModel) {
  function TranslationBasic() {
    var _this;
    _classCallCheck(this, TranslationBasic);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TranslationBasic, [].concat(args));
    _initializerDefineProperty(_this, "meanings", _descriptor, _this);
    _initializerDefineProperty(_this, "originalDeckId", _descriptor2, _this);
    _initializerDefineProperty(_this, "selectedDeckId", _descriptor3, _this);
    // static
    _initializerDefineProperty(_this, "id", _descriptor4, _this);
    _initializerDefineProperty(_this, "simple", _descriptor5, _this);
    _initializerDefineProperty(_this, "source", _descriptor6, _this);
    _initializerDefineProperty(_this, "type", _descriptor7, _this);
    _initializerDefineProperty(_this, "complexity", _descriptor8, _this);
    _initializerDefineProperty(_this, "levelId", _descriptor9, _this);
    _initializerDefineProperty(_this, "plural", _descriptor0, _this);
    _initializerDefineProperty(_this, "label", _descriptor1, _this);
    _initializerDefineProperty(_this, "gender", _descriptor10, _this);
    _initializerDefineProperty(_this, "sentencesCount", _descriptor11, _this);
    _initializerDefineProperty(_this, "hasSentences", _descriptor12, _this);
    _initializerDefineProperty(_this, "enSourcesCount", _descriptor13, _this);
    _initializerDefineProperty(_this, "targetText", _descriptor14, _this);
    _initializerDefineProperty(_this, "targetId", _descriptor15, _this);
    _initializerDefineProperty(_this, "isPrefix", _descriptor16, _this);
    _initializerDefineProperty(_this, "isStem", _descriptor17, _this);
    _initializerDefineProperty(_this, "noPlural", _descriptor18, _this);
    _initializerDefineProperty(_this, "root", _descriptor19, _this);
    _initializerDefineProperty(_this, "useInFeedEntry", _descriptor20, _this);
    _initializerDefineProperty(_this, "excludeFromPublicLists", _descriptor21, _this);
    _initializerDefineProperty(_this, "excludeAsPluralForm", _descriptor22, _this);
    _initializerDefineProperty(_this, "frequencyRanking", _descriptor23, _this);
    _initializerDefineProperty(_this, "pendingApproval", _descriptor24, _this);
    _initializerDefineProperty(_this, "grammarTense", _descriptor25, _this);
    _initializerDefineProperty(_this, "languageId", _descriptor26, _this);
    _initializerDefineProperty(_this, "wordTypeId", _descriptor27, _this);
    _initializerDefineProperty(_this, "useParenthesesOnGender", _descriptor28, _this);
    _initializerDefineProperty(_this, "articleHasApostrophe", _descriptor29, _this);
    _initializerDefineProperty(_this, "articleTakesOppositeGender", _descriptor30, _this);
    _initializerDefineProperty(_this, "articleIsHidden", _descriptor31, _this);
    _initializerDefineProperty(_this, "relatedWordsString", _descriptor32, _this);
    _initializerDefineProperty(_this, "childrenSynonymsString", _descriptor33, _this);
    _initializerDefineProperty(_this, "synonymsCount", _descriptor34, _this);
    _initializerDefineProperty(_this, "meaningsCount", _descriptor35, _this);
    _initializerDefineProperty(_this, "wordDerivationStemsCount", _descriptor36, _this);
    _initializerDefineProperty(_this, "wordDerivationChildrenCount", _descriptor37, _this);
    _initializerDefineProperty(_this, "stressedCharacters", _descriptor38, _this);
    _initializerDefineProperty(_this, "childWordsList", _descriptor39, _this);
    _initializerDefineProperty(_this, "wordType", _descriptor40, _this);
    _initializerDefineProperty(_this, "level", _descriptor41, _this);
    _initializerDefineProperty(_this, "target", _descriptor42, _this);
    _initializerDefineProperty(_this, "rootWord", _descriptor43, _this);
    _initializerDefineProperty(_this, "genderVariant", _descriptor44, _this);
    _initializerDefineProperty(_this, "pluralNouns", _descriptor45, _this);
    _initializerDefineProperty(_this, "concepts", _descriptor46, _this);
    _initializerDefineProperty(_this, "translationSources", _descriptor47, _this);
    _initializerDefineProperty(_this, "meaningSourcePreviews", _descriptor48, _this);
    _initializerDefineProperty(_this, "conjugatedVerbStrings", _descriptor49, _this);
    return _this;
  }
  _inherits(TranslationBasic, _RootModel);
  return _createClass(TranslationBasic, [{
    key: "hasRelatedWords",
    get: function get() {
      var _this$wordType;
      return ((_this$wordType = this.wordType) === null || _this$wordType === void 0 ? void 0 : _this$wordType.name) !== 'Number' && (this.synonymsCount > 0 || this.wordDerivationStemsCount > 0 || this.wordDerivationChildrenCount > 0);
    }
  }, {
    key: "pluralNoun",
    get: function get() {
      return (0, _utils.isPresent)(this.pluralNouns) ? this.pluralNouns[0] : null;
    }
  }, {
    key: "formattedTargetText",
    get: function get() {
      var _this$wordType2;
      if (this.type === 'Word' && (0, _utils.isPresent)((_this$wordType2 = this.wordType) === null || _this$wordType2 === void 0 ? void 0 : _this$wordType2.abbreviation)) {
        return "".concat(this.targetText, " (").concat(this.wordType.abbreviation, ")");
      }
      return this.targetText;
    }
  }, {
    key: "hasWordType",
    get: function get() {
      return (0, _utils.isPresent)(this.wordType) && (0, _utils.isPresent)(this.wordType.id);
    }
  }, {
    key: "wordTypeName",
    get: function get() {
      var wordTypeIdToName = new Map(_constants.Constants.WORD_TYPES.map(function (i) {
        return [i.id, i.name];
      }));
      return (0, _utils.isPresent)(this.wordTypeId) ? wordTypeIdToName.get(this.wordTypeId) : null;
    }
  }, {
    key: "levelAbbreviation",
    get: function get() {
      return (0, _utils.isPresent)(this.level) ? this.level.abbreviation : null;
    }
  }, {
    key: "enTranslationSources",
    get: function get() {
      if ((0, _utils.isBlank)(this.translationSources)) {
        return;
      }
      return (0, _lodash.compact)(this.translationSources.filter(function (item) {
        var _item$source;
        return item.source && ((_item$source = item.source) === null || _item$source === void 0 ? void 0 : _item$source.languageId) === 'EN' && !item.rejected && (!item.userId || item.accepted) && (0, _utils.isBlank)(item.meaningId);
      }));
    }
  }, {
    key: "sourceList",
    get: function get() {
      if ((0, _utils.isBlank)(this.enTranslationSources)) {
        return;
      }
      return this.enTranslationSources.map(function (item) {
        return item.source ? item.source.text : null;
      }).join(', ');
    }
  }, {
    key: "caseAbbreviation",
    get: function get() {
      var concept = this.concepts.find(function (item) {
        return (0, _utils.isPresent)(item.grammarCase);
      });
      if ((0, _utils.isPresent)(concept)) {
        return concept.grammarCase;
      }
      return null;
    }
  }, {
    key: "tenseAbbreviation",
    get: function get() {
      var concept = this.concepts.find(function (item) {
        return (0, _utils.isPresent)(item.grammarTense);
      });
      if ((0, _utils.isPresent)(concept)) {
        return concept.grammarTense;
      }
      return null;
    }
  }, {
    key: "isVerb",
    get: function get() {
      return this.wordTypeId === '4c4389c1-f805-4d1c-ba45-6721cf400aef';
    }
  }, {
    key: "isNoun",
    get: function get() {
      return this.wordTypeId === 'd5c5fcef-bb92-48a8-b00b-e7c71cb33068';
    }
  }, {
    key: "definiteArticle",
    get: function get() {
      if ((0, _utils.isPresent)(this.gender)) {
        var languageId = this.languageId || 'DE';
        var articleGender = !this.articleTakesOppositeGender ? this.gender : this.gender === 'feminine' ? 'masculine' : 'feminine';
        var article;
        if (_constants.Constants.PLURAL_ARTICLES[languageId] && _constants.Constants.PLURAL_ARTICLES[languageId][articleGender]) {
          article = this.plural ? _constants.Constants.PLURAL_ARTICLES[languageId][articleGender] : _constants.Constants.SINGULAR_ARTICLES[languageId][articleGender];
        }
        if (this.useParenthesesOnGender) {
          article = "(".concat(article, ")");
        }
        return article;
      }
      return null;
    }
  }, {
    key: "genderAbbreviationWithoutPlural",
    get: function get() {
      if ((0, _utils.isPresent)(this.gender)) {
        return this.gender[0];
      }
      return null;
    }
  }, {
    key: "genderAbbreviation",
    get: function get() {
      var gender = '';
      if (this.gender === 'feminine') {
        gender = ' (f.)';
      } else if (this.gender === 'masculine' && this.languageId === 'NL') {
        gender = ' (c.)';
      } else if (this.gender === 'masculine') {
        gender = ' (m.)';
      } else if (this.gender === 'neuter') {
        gender = ' (n.)';
      }
      return gender;
    }
  }, {
    key: "targetTextWithDefiniteArticle",
    get: function get() {
      // also in root_word.js, word.js
      if (this.articleIsHidden) {
        return this.targetText;
      }
      if (this.isNoun && this.languageId === 'DE' && this.gender && !this.root && this.caseAbbreviation && !this.plural && _constants.Constants.ARTICLES[this.caseAbbreviation.toLowerCase()] && _constants.Constants.ARTICLES[this.caseAbbreviation.toLowerCase()][this.gender]) {
        return "".concat(_constants.Constants.ARTICLES[this.caseAbbreviation.toLowerCase()][this.gender], " ").concat(this.targetText);
      }
      if (this.isNoun && this.languageId === 'DE' && this.gender && !this.root && this.caseAbbreviation && _constants.Constants.ARTICLES[this.caseAbbreviation.toLowerCase()] && _constants.Constants.ARTICLES[this.caseAbbreviation.toLowerCase()].plural) {
        return "".concat(_constants.Constants.ARTICLES[this.caseAbbreviation.toLowerCase()].plural, " ").concat(this.targetText);
      } else if (this.languageId === 'IT' && this.isNoun && this.gender === 'masculine' && "".concat(_constants.Constants.LETTERS_THAT_TAKE_APOSTROPHE_IN_FR, "szSZ").includes(this.targetText[0])) {
        if (this.plural) {
          return "gli ".concat(this.targetText);
        } else {
          return "lo ".concat(this.targetText);
        }
      } else if (this.languageId === 'CA' && this.isNoun && !this.plural && this.gender) {
        // Catalan specific logic: feminine words beginning with unstressed I, HI, U or HU should NOT take apostrophe
        if (this.articleHasApostrophe || this.shouldTakeApostropheInCatalan() && !this.feminineWordWithNoApostropheInCatalan()) {
          return "l'".concat(this.targetText).concat(this.genderAbbreviation);
        } else {
          return "".concat(this.definiteArticle, " ").concat(this.targetText).concat(this.articleTakesOppositeGender ? this.genderAbbreviation : '');
        }
      } else if (this.isNoun && !this.plural && this.gender && ['FR', 'IT'].includes(this.languageId) && (this.articleHasApostrophe || _constants.Constants.LETTERS_THAT_TAKE_APOSTROPHE_IN_FR.includes(this.targetText[0]))) {
        return "l'".concat(this.targetText).concat(this.languageId !== 'IT' ? this.genderAbbreviation : '');
      } else if (this.isNoun && this.gender && this.definiteArticle) {
        return "".concat(this.definiteArticle, " ").concat(this.targetText).concat(this.articleTakesOppositeGender ? this.genderAbbreviation : '');
      }
      return this.targetText;
    }
  }, {
    key: "shouldTakeApostropheInCatalan",
    value: function shouldTakeApostropheInCatalan() {
      // Most words beginning with a vowel take an apostrophe in Catalan
      return _constants.Constants.LETTERS_THAT_TAKE_APOSTROPHE_IN_CA.includes(this.targetText[0]);
    }
  }, {
    key: "feminineWordWithNoApostropheInCatalan",
    value: function feminineWordWithNoApostropheInCatalan() {
      // Feminine words beginning with unstressed I, HI, U or HU should NOT take apostrophe
      return this.gender === 'feminine' && /^[iu]|^hi|^hu/i.test(this.targetText);
    }
  }, {
    key: "targetTextWithDefiniteArticleAndSource",
    get: function get() {
      return (0, _utils.isPresent)(this.source) ? "".concat(this.targetTextWithDefiniteArticle, " - ").concat(this.source) : this.targetTextWithDefiniteArticle;
    }
  }, {
    key: "dictionaryUrl",
    get: function get() {
      return (0, _utils.isPresent)(this.targetText) ? "http://dict.cc?s=".concat(this.targetText.replace(' ', '+')) : null;
    }
  }, {
    key: "setOriginalDeckId",
    value: function setOriginalDeckId(originalDeckId) {
      this.originalDeckId = originalDeckId;
    }
  }, {
    key: "setSelectedDeckId",
    value: function setSelectedDeckId(selectedDeckId) {
      this.selectedDeckId = selectedDeckId;
    }
  }, {
    key: "publicInVocab",
    get: function get() {
      var _this$wordType3, _this$target;
      // should follow the logic of join_user_translations_service.rb also in word.js
      return ((_this$wordType3 = this.wordType) === null || _this$wordType3 === void 0 ? void 0 : _this$wordType3.showInVocabTrainer) && !this.excludeFromPublicLists && !this.pendingApproval && (0, _utils.isPresent)((_this$target = this.target) === null || _this$target === void 0 ? void 0 : _this$target.videoClip) && this.enSourcesCount > 0;
    }
  }, {
    key: "publicPhrase",
    get: function get() {
      var _this$wordType4, _this$target2;
      return ((_this$wordType4 = this.wordType) === null || _this$wordType4 === void 0 ? void 0 : _this$wordType4.abbreviation) === 'phr' && !this.excludeFromPublicLists && !this.pendingApproval && (0, _utils.isPresent)((_this$target2 = this.target) === null || _this$target2 === void 0 ? void 0 : _this$target2.videoClip) && this.enSourcesCount > 0;
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "meanings", [_mobx.observable, _dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "originalDeckId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "selectedDeckId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "id", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "simple", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "source", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "type", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "complexity", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "levelId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "plural", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "label", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "gender", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "sentencesCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "hasSentences", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "enSourcesCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "targetText", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "targetId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "isPrefix", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "isStem", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "noPlural", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "root", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "useInFeedEntry", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "excludeFromPublicLists", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "excludeAsPluralForm", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "frequencyRanking", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "pendingApproval", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "grammarTense", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "languageId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "wordTypeId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "useParenthesesOnGender", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "articleHasApostrophe", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "articleTakesOppositeGender", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "articleIsHidden", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "relatedWordsString", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "childrenSynonymsString", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "synonymsCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "meaningsCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "wordDerivationStemsCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "wordDerivationChildrenCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "stressedCharacters", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "childWordsList", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "wordType", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "level", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "target", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "rootWord", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "genderVariant", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "pluralNouns", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "concepts", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "translationSources", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor48 = _applyDecoratedDescriptor(_class.prototype, "meaningSourcePreviews", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor49 = _applyDecoratedDescriptor(_class.prototype, "conjugatedVerbStrings", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _class);
var _default = exports["default"] = TranslationBasic;